import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import InputComboGrupa from "../../helpers/InputComboGrupa";
import InputDate from "../../helpers/InputDate";



import { setSelectionRange } from "@testing-library/user-event/dist/utils";
import InputComboSubkonto from "../../helpers/InputComboSubkonto";
import InputComboRok from "../../helpers/InputComboRok";
import InputComboRokMiesiac from "../../helpers/InputComboRokMiesiac";
import InputCombo from "../../helpers/InputCombo";
import InputComboZajecia from "../../helpers/InputComboZajecia";
import InputComboStawki from "../../helpers/InputComboStawki";




import back from "../../back.png";
import fav_n from "../../fav_n.svg";
import fav_y from "../../fav_y.svg";
import rp00000000001 from "../../rp00000000001.png";
import rp00000000003 from "../../rp00000000003.jpg";
import rp00000000004 from "../../rp00000000004.jpg";
import rp00000000005 from "../../rp00000000005.jpg";
import rp00000000006 from "../../rp00000000006.jpg";
import rp00000000007 from "../../rp00000000007.jpg";
import rp00000000008 from "../../rp00000000008.jpg";
import rp00000000009 from "../../rp00000000009.jpg";
import rp00000000010 from "../../rp00000000010.jpg";
import rp00000000011 from "../../rp00000000011.jpg";
import rp00000000012 from "../../rp00000000012.jpg";
import rp00000000013 from "../../rp00000000013.jpg";
import rp00000000014 from "../../rp00000000014.jpg";
import rp00000000015 from "../../rp00000000015.jpg";
import rp00000000016 from "../../rp00000000016.jpg";
import rp00000000017 from "../../rp00000000017.jpg";
import rp00000000018 from "../../rp00000000018.jpg";
import rp00000000019 from "../../rp00000000019.jpg";
import rp00000000020 from "../../rp00000000020.jpg";
import rp00000000021 from "../../rp00000000021.jpg";
import rp00000000022 from "../../rp00000000022.jpg";
import rp00000000023 from "../../rp00000000023.jpg";
import rp00000000024 from "../../rp00000000024.jpg";
import rp00000000025 from "../../rp00000000025.jpg";
import rp00000000026 from "../../rp00000000026.jpg";
import rp00000000027 from "../../rp00000000027.jpg";
import rp00000000028 from "../../rp00000000028.jpg";
import rp00000000029 from "../../rp00000000029.jpg";
import rp00000000030 from "../../rp00000000030.jpg";
import rp00000000031 from "../../rp00000000031.jpg";
import rp00000000032_1 from "../../rp00000000032_1.jpg";
import rp00000000032 from "../../rp00000000032.jpg";
import rp00000000033 from "../../rp00000000033.jpg";
import rp00000000034 from "../../rp00000000034.jpg";
import rp00000000035 from "../../rp00000000035.jpg";
import rp00000000036 from "../../rp00000000036.jpg";
import GmRaportGeneral from "./GmRaportGeneral";
import GmAccounts from "./GmAccounts";



function ToExport(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const [search, setSearch] = useState(props.search);
    const [type, setType]     = useState(props.type);

    const [uqSelected, setUQSelected]     = useState("");


    const getDateYmd = () => {
        const dateObj = new Date();
        const month   = dateObj.getUTCMonth() + 1; // months from 1-12
        const day     = dateObj.getUTCDate();
        const year    = dateObj.getUTCFullYear();

       // const newDate = year + "/" + month + "/" + day;

        // Using template literals:
       // const newDate = `${year}/${month}/${day}`;

        // Using padded values, so that 2023/1/7 becomes 2023/01/07
        const pMonth        = month.toString().padStart(2,"0");
        const pDay          = day.toString().padStart(2,"0");
        const newPaddedDate = `${year}-${pMonth}-${pDay}`;

        return newPaddedDate;
}


    const [filterParam, setFilterParam] = useState({
    
        nazwisko: '',
        d_nazwisko: '',
        imie: '',  
        d_imie: '',  
        grupa: '',  
        stawka: '',  
        data_od: getDateYmd(),  
        data_do: getDateYmd(),  
        miesiac: '',  

        extra_combo: '_x_',

        okres_od: getDateYmd(),
        okres_do: getDateYmd(),

        rok:  (new Date()).getUTCFullYear() ,

        wiek: '12',

        okres: '',
        p_subkonta_id: "_x_",
        p_zajecia_dodatkowe_id: '_x_',
        typ: "_x_",

        tydzien: '_x_',

    });



    var raportList =  [
        {   pdf: true, xls: true, uq: "00000000001", fav: false, type: "all",     name: "Wpłaty rodziców", review: rp00000000001  },     
        {   pdf: true, xls: true, uq: "00000000003", fav: false, type: "all",     name: "Rozliczenie należności i sald - raport zbiorczy",  review: rp00000000003 },
        {   pdf: true, xls: true, uq: "00000000004", fav: false, type: "all",     name: "Lista dzieci (umowy, stawki)",  review: rp00000000004   },
        {   pdf: true, xls: true, uq: "00000000005", fav: false, type: "all",     name: "Lista pracowników" ,  review: rp00000000005  },
        {   pdf: true, xls: true, uq: "00000000006", fav: false, type: "all",     name: "Lista aktywnych umów" ,  review: rp00000000006  },
        {   pdf: true, xls: true, uq: "00000000007", fav: false, type: "all",     name: "Wykaz zdefiniowanych stawek" ,  review: rp00000000007  },
        {   pdf: true, xls: true, uq: "00000000008", fav: false, type: "all",     name: "Wykaz nieobecności - dzieci",  review: rp00000000008 },
        {   pdf: true, xls: true, uq: "00000000009", fav: false, type: "all",     name: "Wykaz nieobecności - dzieci - kto zgłosił" ,  review: rp00000000009 },
        {   pdf: true, xls: true, uq: "00000000010", fav: false, type: "all",     name: "Wykaz nieobecności - pracowników" ,  review: rp00000000010  },

        {   pdf: true, xls: true, uq: "00000000011", fav: false, type: "all",     name: "Wykaz godzin pobytu" ,  review: rp00000000011   },
        {   pdf: true, xls: true, uq: "00000000012", fav: false, type: "all",     name: "Wykaz nadgodzin" ,  review: rp00000000012   },
        {   pdf: true, xls: true, uq: "00000000013", fav: false, type: "all",     name: "Zajęcia dodatkowe - wykaz dzieci" ,  review: rp00000000013  },
        {   pdf: true, xls: true, uq: "00000000014", fav: false, type: "all",     name: "Zajęcia dodatkowe - obecności",  review: rp00000000014  },
        {   pdf: true, xls: true, uq: "00000000015", fav: false, type: "all",     name: "Opłaty za pobyt / wyżywienie" ,  review: rp00000000015 },
        {   pdf: true, xls: true, uq: "00000000016", fav: false, type: "all",     name: "Szczegóły rozliczeń" ,  review: rp00000000016  },
        {   pdf: true, xls: true, uq: "00000000017", fav: false, type: "all",     name: "Szczegóły rozliczeń v2" ,  review: rp00000000017 },
        {   pdf: true, xls: true, uq: "00000000018", fav: false, type: "all",     name: "Szczegóły rozliczeń v2 Przypis"  ,  review: rp00000000018 },
        {   pdf: true, xls: true, uq: "00000000019", fav: false, type: "all",     name: "Posiłki - Ilości" ,  review: rp00000000019 },
        {   pdf: true, xls: true, uq: "00000000020", fav: false, type: "all",     name: "Szczegóły rozliczeń v3",   review: rp00000000020 },
        {   pdf: true, xls: true, uq: "00000000021", fav: false, type: "all",     name: "Szczegóły rozliczeń v3  Przypis",    review: rp00000000021 },

        {   pdf: true, xls: true, uq: "00000000022", fav: false, type: "all",     name: "Przypis P1 (placówki publiczne) " ,    review: rp00000000022 },
        {   pdf: false, xls: true, uq: "00000000023", fav: false, type: "all",     name: "Bilans roczny SALD" ,    review: rp00000000023  },
        {   pdf: false, xls: true, uq: "00000000024", fav: false, type: "all",     name: "Raport umów oczekujących na podpis" ,    review: rp00000000024  },
        {   pdf: false, xls: true, uq: "00000000025", fav: false, type: "all",     name: "Raport wydanych posiłków wg. rozliczeń"  ,    review: rp00000000025  } ,
        {   pdf: false, xls: true, uq: "00000000026", fav: false, type: "all",     name: "Dane do 400+" ,    review: rp00000000026  },

        {   pdf: true, xls: true, uq: "00000000027", fav: false, type: "all",     name: "Raport przychodów" ,    review: rp00000000027  },
        {   pdf: true, xls: true, uq: "00000000028", fav: false, type: "all",     name: "Zestawienie pozycji z rachunków",   review: rp00000000028  },
        {   pdf: true, xls: true, uq: "00000000029", fav: false, type: "all",     name: "OsoboDni / GUS",   review: rp00000000029  },
        {   pdf: true, xls: true, uq: "00000000030", fav: false, type: "all",     name: "Raport aktywnych umów" ,   review: rp00000000030  },
        {   pdf: true, xls: true, uq: "00000000031", fav: false, type: "all",     name: "Dzieci kończące [X] lat (w tym miesiącu) " ,   review: rp00000000031  },
        {   pdf: true, xls: true, uq: "00000000032_1", fav: false, type: "all",     name: "Raport zbiorczy",   review: rp00000000032_1 },
        {   pdf: true, xls: true, uq: "00000000032", fav: false, type: "all",     name: "Raport zbiorczy V2 (uwzględniając korekty) ",   review: rp00000000032 },
        {   pdf: true, xls: true, uq: "00000000033", fav: false, type: "all",     name: "Przelewy -> rozliczenia",   review: rp00000000033 },
       // {   pdf: true, xls: true, uq: "00000000034", fav: false, type: "all",     name: "Dziecko - historia obecności"},

        {   pdf: true, xls: true, uq: "00000000034", fav: false, type: "all",     name: "Nadpłaty i niedopłaty na saldzie",   review: rp00000000034 },

        {   pdf: true, xls: true, uq: "00000000035", fav: false, type: "all",     name: "Rachunki i faktury - podsumowanie pozycji",  review: rp00000000035},

        {   pdf: true, xls: true, uq: "00000000036", fav: false, type: "all",     name: "Lista dzieci wg. tygodni", review: rp00000000036 },

        {   pdf: true, xls: true, uq: "00000000037", fav: false, type: "all",     name: "Dla gmin - raport ogólny", review: null },
        {   pdf: true, xls: true, uq: "00000000038", fav: false, type: "all",     name: "Dla gmin - bilans kont"  , review: null },
        

        {   pdf: false, xls: false, epp:true, uq: "00000000039", fav: false, type: "all",     name: "Rewizor, Nexo, epp"  , review: null },


        {   pdf: true, xls: true, epp:false, uq: "00000000040", fav: false, type: "all",     name: "Wpisowe (impreza okolicznościowa)"  , review: null },


        {   pdf: false, xls: false, xml:true, uq: "00000000100", fav: false, type: "all",     name: "JPK VAT"  , review: null },
        {   pdf: false, xls: false, xml:true, uq: "00000000100FA", fav: false, type: "all",     name: "JPK VAT FA"  , review: null },
        {   pdf: false, xls: false, zip:true, uq: "00000000101", fav: false, type: "all",     name: "Comarch ERP Optima"  , review: null },

    ];


    const [list, setList] = useState(raportList);


    const [fav, setFav] = useState(null);



 const getFav = (e) => {

 
 
        var req = {};    
        props.mainView.setProgress(-2);       

        fetch( Config.master + '/rest_v1_rap,get_fav', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setFav( res.result ); 
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                

    }


 const addFav = (e) => {

 
        var n = e.target.getAttribute('nazwa');
        var uq = e.target.getAttribute('uq');
 
        var req = {
            nazwa: n,
            uq: uq,
        };    



        props.mainView.setProgress(-2);       

        fetch( Config.master + '/rest_v1_rap,add_fav', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        getFav();

                         props.mainView.showDialog( "Sukces!", "Raport został dodany do ulubionych." , "ok" , null);  
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                

    }

const removeFav = (e) => {

 
        var n = e.target.getAttribute('nazwa');
        var uq = e.target.getAttribute('uq');
 
        var req = {
            nazwa: n,
            uq: uq,
        };    



        props.mainView.setProgress(-2);       

        fetch( Config.master + '/rest_v1_rap,remove_fav', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        getFav();
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                

    }


    const goRaport = (e) => {

            var uq = e.target.getAttribute("atr-type");  
            setUQSelected(uq);          
    }

    const goDownload = (e) => {

        var format = e.target.getAttribute("atr-format");

        

        var req = filterParam;
        req["uq"] = uqSelected;
        req["format"] = format;

        props.mainView.setProgress(-2);

       

        fetch( Config.master + '/rest_v1_rap,go_download', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                            //  setTab(res.result);    
                                var format = res.format;                                
                                var pdfB64 = res.result;

                                if(format == 'pdf')
                                {
                                    let linkB = Config.makeBase64PDFToBlobUrl(pdfB64); 
                                    var anchor = document.createElement('a');
                                    anchor.href = linkB;
                                    anchor.target="_blank";
                                    anchor.click();
                                }

                                if(format == "xls")
                                {
                                    let linkB = Config.makeBase64ELSToBlobUrl(pdfB64); 
                                    var anchor = document.createElement('a');
                                    anchor.href = linkB;
                                    anchor.target="_blank";
                                    anchor.click();
                                }
                     
                                if(format == "xml")
                                {
                                    let linkB = Config.makeBase64XMLToBlobUrl(pdfB64); 
                                    var anchor = document.createElement('a');
                                    anchor.href = linkB;
                                    anchor.target="_blank";
                                    anchor.setAttribute('download', "jpk.xml");
                                    anchor.click();
                                }

                                
                                if(format == "zip")
                                {
                                    let linkB = Config.makeBase64XMLToBlobUrl(pdfB64); 
                                    var anchor = document.createElement('a');
                                    anchor.href = linkB;
                                    anchor.target="_blank";
                                    anchor.setAttribute('download', "optima.zip");
                                    anchor.click();
                                }

                                if(format == "epp")
                                {
                                    let linkB = Config.makeBase64EppToBlobUrl(pdfB64); 
                                    var anchor = document.createElement('a');
                                    anchor.href = linkB;
                                    anchor.target="_blank";
                                    anchor.setAttribute('download', "dokumenty.epp");
                                    anchor.click();
                                }

                              

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                

    }


    const onBack = () => {

        setUQSelected("");
    }

    const valChangeListener = (filedName, val, correct, msg) => {

        // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );              
        props.mainView.writeFilter(filedName, val);
    }


    var showPDF = false;
    var showXLS = false;

    var xTitle = "";

    if(uqSelected != '')
    {
        for(var k=0; k<list.length; k++)
        {
            if(list[k].uq == uqSelected)
            {
              if(list[k].pdf) showPDF = true;
              if(list[k].xls) showXLS = true;
              xTitle = list[k].name;
            }
        }
    }



    if(search != props.search)
    {
        setSearch(props.search);
    }


    if(fav == null )
    {
        setFav([]);
        getFav();
        return <span>....</span>;
    }




    if(uqSelected == "00000000001")
    {

        return  <form className="eForm bg_center">

                            <br/>
                            <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                            <h3>{xTitle}</h3>    

                            <div className="form_tab">

                                            <div className="form_control">
                                                <div className="fieldName">Grupa</div>
                                                <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                            </div>
                                
                                            <div className="form_control">
                                                <div className="fieldName">Od dnia</div>
                                                <InputDate   value={filterParam.data_od} err={null}  valChange={valChangeListener} goNext={null} name="data_od" placeholder={""} className='  ' req='0' firstUp="0" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Do dnia</div>
                                                <InputDate   value={filterParam.data_do} err={null}  valChange={valChangeListener} goNext={null} name="data_do" placeholder={""} className='  ' req='0' firstUp="0" />
                                            </div>

                                              <div className="form_control">
                                                <div className="fieldName">Nazwisko rodzica</div>
                                                <InputText   userData={props.userData} value={filterParam.nazwisko} err={null}  valChange={valChangeListener} goNext={null} name="nazwisko" placeholder={""} className=' w200 ' req='0' firstUp="0" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Imie rodzica</div>
                                                <InputText   userData={props.userData} value={filterParam.imie} err={null}  valChange={valChangeListener} goNext={null} name="imie" placeholder={""} className=' w200 ' req='0' firstUp="0" />
                                            </div>


                                               <div className="form_control">
                                                <div className="fieldName">Nazwisko dziecka</div>
                                                <InputText   userData={props.userData} value={filterParam.d_nazwisko} err={null}  valChange={valChangeListener} goNext={null} name="d_nazwisko" placeholder={""} className=' w200 ' req='0' firstUp="0" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Imie dziecka</div>
                                                <InputText   userData={props.userData} value={filterParam.d_imie} err={null}  valChange={valChangeListener} goNext={null} name="d_imie" placeholder={""} className=' w200 ' req='0' firstUp="0" />
                                            </div>

                                           <div className="form_control">
                                                <div className="fieldName">Typ</div>
                                                <InputCombo  items={  [{v:'_x_',title:'Wszystko'} , {v:'ma',title:'MA - Uznania'},  {v:'wn',title:'WN - Obciążenia (zwroty)'} ] }  value={filterParam.typ} err={null}  valChange={valChangeListener} goNext={null} name="typ" placeholder={""} className=' ' req='0' firstUp="0" />
                                            </div>
                            </div>

                            
                            <div className="form_split"></div>

                            <div className="form_btn">
                                    {
                                        showPDF &&
                                        <Fragment>
                                            <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                            &nbsp;&nbsp;
                                        </Fragment>    
                                    }

                                    {
                                        showXLS &&
                                        <Fragment>
                                            <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                            &nbsp;&nbsp;
                                        </Fragment>    
                                    }
                              
                            </div>
        </form>

    }


    if(uqSelected == "00000000002")
        {
    
            return  <form className="eForm bg_center">
    
                                <br/>
                                <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                <h3>{xTitle}</h3>    
    
                                <div className="form_tab">
    
                                                <div className="form_control">
                                                    <div className="fieldName">Grupa</div>
                                                    <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                                </div>
                                    
                                                <div className="form_control">
                                                    <div className="fieldName">Od dnia</div>
                                                    <InputDate   value={filterParam.data_od} err={null}  valChange={valChangeListener} goNext={null} name="data_od" placeholder={""} className='  ' req='0' firstUp="0" />
                                                </div>
    
                                                <div className="form_control">
                                                    <div className="fieldName">Do dnia</div>
                                                    <InputDate   value={filterParam.data_do} err={null}  valChange={valChangeListener} goNext={null} name="data_do" placeholder={""} className='  ' req='0' firstUp="0" />
                                                </div>
    
                                                  <div className="form_control">
                                                    <div className="fieldName">Nazwisko rodzica</div>
                                                    <InputText   userData={props.userData} value={filterParam.nazwisko} err={null}  valChange={valChangeListener} goNext={null} name="nazwisko" placeholder={""} className=' w200 ' req='0' firstUp="0" />
                                                </div>
    
                                                <div className="form_control">
                                                    <div className="fieldName">Imie rodzica</div>
                                                    <InputText   userData={props.userData} value={filterParam.imie} err={null}  valChange={valChangeListener} goNext={null} name="imie" placeholder={""} className=' w200 ' req='0' firstUp="0" />
                                                </div>
                                </div>
    
                                
                                <div className="form_split"></div>
    
                                <div className="form_btn">
                                        {
                                            showPDF &&
                                            <Fragment>
                                                <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }
    
                                        {
                                            showXLS &&
                                            <Fragment>
                                                <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }
                                  
                                </div>
            </form>
    
        }
   
        
    if(uqSelected == "00000000003")
            {
        
                return  <form className="eForm bg_center">
        
                                    <br/>
                                    <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                    <h3>{xTitle}</h3>    
        
                                    <div className="form_tab">
        
                                                    <div className="form_control">
                                                        <div className="fieldName">Subkonto</div>
                                                        <InputComboSubkonto userData={props.userData} mainView={props.mainView}   value={filterParam.p_subkonta_id} err={null}  valChange={valChangeListener} goNext={null} name="p_subkonta_id" placeholder={""} className=' ' req='0' noempty="0" />
                                                    </div>

                                                    <div className="form_control">
                                                        <div className="fieldName">Okres</div>
                                                        <InputComboRokMiesiac userData={props.userData} mainView={props.mainView}   value={filterParam.okres} err={null}  valChange={valChangeListener} goNext={null} name="okres" placeholder={""} className=' ' req='0' noempty="0" />
                                                    </div>
                                         
                                    </div>                                   
        
                                    
                                    <div className="form_split"></div>
        
                                    <div className="form_btn">
                                            {
                                                showPDF &&
                                                <Fragment>
                                                    <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                    &nbsp;&nbsp;
                                                </Fragment>    
                                            }
        
                                            {
                                                showXLS &&
                                                <Fragment>
                                                    <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                    &nbsp;&nbsp;
                                                </Fragment>    
                                            }
                                      
                                    </div>
                </form>
        
            }


    if(uqSelected == "00000000004")
                {
            
                    return  <form className="eForm bg_center">
            
                                        <br/>
                                        <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                        <h3>{xTitle}</h3>    
            
                                        <div className="form_tab">
            
                                                        <div className="form_control">
                                                            <div className="fieldName">Grupa</div>
                                                            <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                                        </div>                                             
                                        </div>
            
                                        
                                        <div className="form_split"></div>
            
                                        <div className="form_btn">
                                                {
                                                    showPDF &&
                                                    <Fragment>
                                                        <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                        &nbsp;&nbsp;
                                                    </Fragment>    
                                                }
            
                                                {
                                                    showXLS &&
                                                    <Fragment>
                                                        <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                        &nbsp;&nbsp;
                                                    </Fragment>    
                                                }
                                          
                                        </div>
                    </form>
            
                }
           
    if(uqSelected == "00000000005")
                    {
                        var items =  [
                            { v: '_x_', title: "Wszyscy" },
                            { v: 'OPIEKUN', title: "Opiekun" },
                            { v: 'Inny', title: "Inny pracownik" },
                        ];
                
                        return  <form className="eForm bg_center">
                
                                            <br/>
                                            <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                            <h3>{xTitle}</h3>    
                
                                            <div className="form_tab">
                
                                                            <div className="form_control">
                                                                <div className="fieldName">Grupa</div>
                                                                <InputCombo  items={items} userData={props.userData} mainView={props.mainView}   value={filterParam.typ} err={null}  valChange={valChangeListener} goNext={null} name="typ" placeholder={""} className=' ' req='0'   />
                                                            </div>                                             
                                            </div>
                
                                            
                                            <div className="form_split"></div>
                
                                            <div className="form_btn">
                                                    {
                                                        showPDF &&
                                                        <Fragment>
                                                            <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                            &nbsp;&nbsp;
                                                        </Fragment>    
                                                    }
                
                                                    {
                                                        showXLS &&
                                                        <Fragment>
                                                            <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                            &nbsp;&nbsp;
                                                        </Fragment>    
                                                    }
                                              
                                            </div>
                        </form>
                
                    }
   
    if(uqSelected == "00000000006")
                  {
                    
                            return  <form className="eForm bg_center">
                    
                                                <br/>
                                                <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                                <h3>{xTitle}</h3>    
                    
                                                <div className="form_tab">
                    
                                                                <div className="form_control">
                                                                    <div className="fieldName">Grupa</div>
                                                                    <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                                                </div>                                             
                                                </div>
                    
                                                
                                                <div className="form_split"></div>
                    
                                                <div className="form_btn">
                                                        {
                                                            showPDF &&
                                                            <Fragment>
                                                                <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                                &nbsp;&nbsp;
                                                            </Fragment>    
                                                        }
                    
                                                        {
                                                            showXLS &&
                                                            <Fragment>
                                                                <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                                &nbsp;&nbsp;
                                                            </Fragment>    
                                                        }
                                                  
                                                </div>
                            </form>
                    
                        }
                                  
    if(uqSelected == "00000000007")
                {
                    var items =  [
                        { v: '_x_', title: "Wszystkie" },
                        { v: 'm', title: "Miesięczne" },                        
                        { v: 'd', title: "Dniowe" },                        
                        { v: 'g', title: "Godzinowe" },                        
                        { v: 'n', title: "Nadgodzinowe" },                        
                        { v: 'j', title: "Jednorazowe" },                        
                    ];
            
                    return  <form className="eForm bg_center">
            
                                        <br/>
                                        <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                        <h3>{xTitle}</h3>    
            
                                        <div className="form_tab">
            
                                                        <div className="form_control">
                                                            <div className="fieldName">Rodzaj</div>
                                                            <InputCombo  items={items} userData={props.userData} mainView={props.mainView}   value={filterParam.typ} err={null}  valChange={valChangeListener} goNext={null} name="typ" placeholder={""} className=' ' req='0'   />
                                                        </div>                                             
                                        </div>
            
                                        
                                        <div className="form_split"></div>
            
                                        <div className="form_btn">
                                                {
                                                    showPDF &&
                                                    <Fragment>
                                                        <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                        &nbsp;&nbsp;
                                                    </Fragment>    
                                                }
            
                                                {
                                                    showXLS &&
                                                    <Fragment>
                                                        <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                        &nbsp;&nbsp;
                                                    </Fragment>    
                                                }
                                        
                                        </div>
                    </form>
                }           
     
                
    if(uqSelected == "00000000008")
        {
    
            return  <form className="eForm bg_center">
    
                                <br/>
                                <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                <h3>{xTitle}</h3>    
    
                                <div className="form_tab">
    
                                                <div className="form_control">
                                                    <div className="fieldName">Grupa</div>
                                                    <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                                </div>
                                                
                                    
                                                <div className="form_control">
                                                    <div className="fieldName">Od dnia</div>
                                                    <InputDate   value={filterParam.data_od} err={null}  valChange={valChangeListener} goNext={null} name="data_od" placeholder={""} className='  ' req='0' firstUp="0" />
                                                </div>
    
                                                <div className="form_control">
                                                    <div className="fieldName">Do dnia</div>
                                                    <InputDate   value={filterParam.data_do} err={null}  valChange={valChangeListener} goNext={null} name="data_do" placeholder={""} className='  ' req='0' firstUp="0" />
                                                </div>
    
                                                    <div className="form_control">
                                                    <div className="fieldName">Nazwisko dzieka</div>
                                                    <InputText   userData={props.userData} value={filterParam.nazwisko} err={null}  valChange={valChangeListener} goNext={null} name="nazwisko" placeholder={""} className=' w200 ' req='0' firstUp="0" />
                                                </div>
    
                                                <div className="form_control">
                                                    <div className="fieldName">Imie dziecka</div>
                                                    <InputText   userData={props.userData} value={filterParam.imie} err={null}  valChange={valChangeListener} goNext={null} name="imie" placeholder={""} className=' w200 ' req='0' firstUp="0" />
                                                </div>
                                </div>
    
                                
                                <div className="form_split"></div>
    
                                <div className="form_btn">
                                        {
                                            showPDF &&
                                            <Fragment>
                                                <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }
    
                                        {
                                            showXLS &&
                                            <Fragment>
                                                <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }
                                    
                                </div>
            </form>
    
        }
                

                
    if(uqSelected == "00000000009")
        {
    
            return  <form className="eForm bg_center">
    
                                <br/>
                                <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                <h3>{xTitle}</h3>    
    
                                <div className="form_tab">
     
                                                
                                    
                                                <div className="form_control">
                                                    <div className="fieldName">Od dnia</div>
                                                    <InputDate   value={filterParam.data_od} err={null}  valChange={valChangeListener} goNext={null} name="data_od" placeholder={""} className='  ' req='0' firstUp="0" />
                                                </div>
    
                                                <div className="form_control">
                                                    <div className="fieldName">Do dnia</div>
                                                    <InputDate   value={filterParam.data_do} err={null}  valChange={valChangeListener} goNext={null} name="data_do" placeholder={""} className='  ' req='0' firstUp="0" />
                                                </div>
    
                                                    <div className="form_control">
                                                    <div className="fieldName">Nazwisko dzieka</div>
                                                    <InputText   userData={props.userData} value={filterParam.nazwisko} err={null}  valChange={valChangeListener} goNext={null} name="nazwisko" placeholder={""} className=' w200 ' req='0' firstUp="0" />
                                                </div>
    
                                                <div className="form_control">
                                                    <div className="fieldName">Imie dziecka</div>
                                                    <InputText   userData={props.userData} value={filterParam.imie} err={null}  valChange={valChangeListener} goNext={null} name="imie" placeholder={""} className=' w200 ' req='0' firstUp="0" />
                                                </div>
                                </div>
    
                                
                                <div className="form_split"></div>
    
                                <div className="form_btn">
                                        {
                                            showPDF &&
                                            <Fragment>
                                                <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }
    
                                        {
                                            showXLS &&
                                            <Fragment>
                                                <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }
                                    
                                </div>
            </form>
    
        }
                    
        
        
    if(uqSelected == "00000000010")
        {
    
            return  <form className="eForm bg_center">
    
                                <br/>
                                <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                <h3>{xTitle}</h3>    
    
                                <div className="form_tab">
        
                                                
                                    
                                                <div className="form_control">
                                                    <div className="fieldName">Od dnia</div>
                                                    <InputDate   value={filterParam.data_od} err={null}  valChange={valChangeListener} goNext={null} name="data_od" placeholder={""} className='  ' req='0' firstUp="0" />
                                                </div>
    
                                                <div className="form_control">
                                                    <div className="fieldName">Do dnia</div>
                                                    <InputDate   value={filterParam.data_do} err={null}  valChange={valChangeListener} goNext={null} name="data_do" placeholder={""} className='  ' req='0' firstUp="0" />
                                                </div>
    
                                                    <div className="form_control">
                                                    <div className="fieldName">Nazwisko</div>
                                                    <InputText   userData={props.userData} value={filterParam.nazwisko} err={null}  valChange={valChangeListener} goNext={null} name="nazwisko" placeholder={""} className=' w200 ' req='0' firstUp="0" />
                                                </div>
    
                                                <div className="form_control">
                                                    <div className="fieldName">Imie</div>
                                                    <InputText   userData={props.userData} value={filterParam.imie} err={null}  valChange={valChangeListener} goNext={null} name="imie" placeholder={""} className=' w200 ' req='0' firstUp="0" />
                                                </div>
                                </div>
    
                                
                                <div className="form_split"></div>
    
                                <div className="form_btn">
                                        {
                                            showPDF &&
                                            <Fragment>
                                                <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }
    
                                        {
                                            showXLS &&
                                            <Fragment>
                                                <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }
                                    
                                </div>
            </form>
    
        }
                        
       


    if(uqSelected == "00000000011")
        {

            return  <form className="eForm bg_center">

                                <br/>
                                <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                <h3>{xTitle}</h3>    

                                <div className="form_tab">
        
                                                <div className="form_control">
                                                    <div className="fieldName">Grupa</div>
                                                    <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                                </div>
                                                
                                    
                                                <div className="form_control">
                                                    <div className="fieldName">Od dnia</div>
                                                    <InputDate   value={filterParam.data_od} err={null}  valChange={valChangeListener} goNext={null} name="data_od" placeholder={""} className='  ' req='0' firstUp="0" />
                                                </div>

                                                <div className="form_control">
                                                    <div className="fieldName">Do dnia</div>
                                                    <InputDate   value={filterParam.data_do} err={null}  valChange={valChangeListener} goNext={null} name="data_do" placeholder={""} className='  ' req='0' firstUp="0" />
                                                </div>

                                                    <div className="form_control">
                                                    <div className="fieldName">Nazwisko</div>
                                                    <InputText   userData={props.userData} value={filterParam.nazwisko} err={null}  valChange={valChangeListener} goNext={null} name="nazwisko" placeholder={""} className=' w200 ' req='0' firstUp="0" />
                                                </div>

                                                <div className="form_control">
                                                    <div className="fieldName">Imie</div>
                                                    <InputText   userData={props.userData} value={filterParam.imie} err={null}  valChange={valChangeListener} goNext={null} name="imie" placeholder={""} className=' w200 ' req='0' firstUp="0" />
                                                </div>
                                </div>

                                
                                <div className="form_split"></div>

                                <div className="form_btn">
                                        {
                                            showPDF &&
                                            <Fragment>
                                                <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }

                                        {
                                            showXLS &&
                                            <Fragment>
                                                <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }
                                    
                                </div>
            </form>

        }        



    if(uqSelected == "00000000012")
            {
    
                return  <form className="eForm bg_center">
    
                                    <br/>
                                    <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                    <h3>{xTitle}</h3>    
    
                                    <div className="form_tab">
            
                                                    <div className="form_control">
                                                        <div className="fieldName">Grupa</div>
                                                        <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                                    </div>
                                                    
                                        
                                                    <div className="form_control">
                                                        <div className="fieldName">Od dnia</div>
                                                        <InputDate   value={filterParam.data_od} err={null}  valChange={valChangeListener} goNext={null} name="data_od" placeholder={""} className='  ' req='0' firstUp="0" />
                                                    </div>
    
                                                    <div className="form_control">
                                                        <div className="fieldName">Do dnia</div>
                                                        <InputDate   value={filterParam.data_do} err={null}  valChange={valChangeListener} goNext={null} name="data_do" placeholder={""} className='  ' req='0' firstUp="0" />
                                                    </div>
    
                                                        <div className="form_control">
                                                        <div className="fieldName">Nazwisko</div>
                                                        <InputText   userData={props.userData} value={filterParam.nazwisko} err={null}  valChange={valChangeListener} goNext={null} name="nazwisko" placeholder={""} className=' w200 ' req='0' firstUp="0" />
                                                    </div>
    
                                                    <div className="form_control">
                                                        <div className="fieldName">Imie</div>
                                                        <InputText   userData={props.userData} value={filterParam.imie} err={null}  valChange={valChangeListener} goNext={null} name="imie" placeholder={""} className=' w200 ' req='0' firstUp="0" />
                                                    </div>
                                    </div>
    
                                    
                                    <div className="form_split"></div>
    
                                    <div className="form_btn">
                                            {
                                                showPDF &&
                                                <Fragment>
                                                    <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                    &nbsp;&nbsp;
                                                </Fragment>    
                                            }
    
                                            {
                                                showXLS &&
                                                <Fragment>
                                                    <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                    &nbsp;&nbsp;
                                                </Fragment>    
                                            }
                                        
                                    </div>
                </form>
    
            }        
    


    if(uqSelected == "00000000013")
                {
        
                    return  <form className="eForm bg_center">
        
                                        <br/>
                                        <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                        <h3>{xTitle}</h3>    
        
                                        <div className="form_tab">
                
                                                        <div className="form_control">
                                                            <div className="fieldName">Grupa</div>
                                                            <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                                        </div>

                                                        <div className="form_control">
                                                            <div className="fieldName">Zajęcia dodatkowe</div>
                                                            <InputComboZajecia  userData={props.userData} mainView={props.mainView}   value={filterParam.p_zajecia_dodatkowe_id} err={null}  valChange={valChangeListener} goNext={null} name="p_zajecia_dodatkowe_id" placeholder={""} className=' ' req='0' firstUp="0" />
                                                        </div>
                                                        
                                             
                                        </div>
        
                                        
                                        <div className="form_split"></div>
        
                                        <div className="form_btn">
                                                {
                                                    showPDF &&
                                                    <Fragment>
                                                        <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                        &nbsp;&nbsp;
                                                    </Fragment>    
                                                }
        
                                                {
                                                    showXLS &&
                                                    <Fragment>
                                                        <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                        &nbsp;&nbsp;
                                                    </Fragment>    
                                                }
                                            
                                        </div>
                    </form>
        
                }        
       

    if(uqSelected == "00000000014")
        {

            return  <form className="eForm bg_center">

                                <br/>
                                <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                <h3>{xTitle}</h3>    

                                <div className="form_tab">

                                                <div className="form_control">
                                                    <div className="fieldName">Okres</div>
                                                    <InputComboRokMiesiac  userData={props.userData} mainView={props.mainView}   value={filterParam.miesiac} err={null}  valChange={valChangeListener} goNext={null} name="miesiac" placeholder={""} className=' ' req='0' firstUp="0" />
                                                </div>
        
                                                <div className="form_control">
                                                    <div className="fieldName">Grupa</div>
                                                    <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                                </div>

                                                <div className="form_control">
                                                    <div className="fieldName">Zajęcia dodatkowe</div>
                                                    <InputComboZajecia  userData={props.userData} mainView={props.mainView}   value={filterParam.p_zajecia_dodatkowe_id} err={null}  valChange={valChangeListener} goNext={null} name="p_zajecia_dodatkowe_id" placeholder={""} className=' ' req='0' firstUp="0" />
                                                </div>
                                                
                                        
                                </div>

                                
                                <div className="form_split"></div>

                                <div className="form_btn">
                                        {
                                            showPDF &&
                                            <Fragment>
                                                <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }

                                        {
                                            showXLS &&
                                            <Fragment>
                                                <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }
                                    
                                </div>
            </form>

        }        


    if(uqSelected == "00000000015")
        {

            var items = [
                { v:'_x_', title:'Wszystkie' } ,
                { v:'w', title:'Pokaż tylko wyżywienie' } ,
                { v:'c', title:'Tylko czesne' } ,
                { v:'d', title:'Tylko stawka dzienna' } ,
                { v:'m', title:'Tylko stawka miesięczna' } ,
                { v:'g', title:'Tylko stawka godzinowa' } ,
                { v:'n', title:'Tylko stawka za nadgodziny' } ,
                { v:'z', title:'Zajęcia dodatkowe' } ,
            ];

            return  <form className="eForm bg_center">

                                <br/>
                                <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                <h3>{xTitle}</h3>    

                                <div className="form_tab">

                                                <div className="form_control">
                                                    <div className="fieldName">Okres</div>
                                                    <InputComboRokMiesiac  userData={props.userData} mainView={props.mainView}   value={filterParam.miesiac} err={null}  valChange={valChangeListener} goNext={null} name="miesiac" placeholder={""} className=' ' req='0' firstUp="0" />
                                                </div>
        
                                                <div className="form_control">
                                                    <div className="fieldName">Grupa</div>
                                                    <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                                </div>

                                                <div className="form_control">
                                                    <div className="fieldName">Stawka</div>
                                                    <InputCombo items={items}  userData={props.userData} mainView={props.mainView}   value={filterParam.stawka} err={null}  valChange={valChangeListener} goNext={null} name="stawka" placeholder={""} className=' ' req='0' firstUp="0" />
                                                </div>
                                                
                                        
                                </div>

                                
                                <div className="form_split"></div>

                                <div className="form_btn">
                                        {
                                            showPDF &&
                                            <Fragment>
                                                <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }

                                        {
                                            showXLS &&
                                            <Fragment>
                                                <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }
                                    
                                </div>
            </form>

        }        


    if(uqSelected == "00000000016")
            {
     
                return  <form className="eForm bg_center">
    
                                    <br/>
                                    <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                    <h3>{xTitle}</h3>    
    
                                    <div className="form_tab">
    
                                                    <div className="form_control">
                                                        <div className="fieldName">Okres</div>
                                                        <InputComboRokMiesiac  userData={props.userData} mainView={props.mainView}   value={filterParam.miesiac} err={null}  valChange={valChangeListener} goNext={null} name="miesiac" placeholder={""} className=' ' req='0' firstUp="0" />
                                                    </div>
            
                                                    <div className="form_control">
                                                        <div className="fieldName">Grupa</div>
                                                        <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                                    </div>     
                                                    
                                            
                                    </div>
    
                                    
                                    <div className="form_split"></div>
    
                                    <div className="form_btn">
                                            {
                                                showPDF &&
                                                <Fragment>
                                                    <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                    &nbsp;&nbsp;
                                                </Fragment>    
                                            }
    
                                            {
                                                showXLS &&
                                                <Fragment>
                                                    <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                    &nbsp;&nbsp;
                                                </Fragment>    
                                            }
                                        
                                    </div>
                </form>
    
            }        
    
    if(uqSelected == "00000000017")
        {
    
            return  <form className="eForm bg_center">

                                <br/>
                                <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                <h3>{xTitle}</h3>    

                                <div className="form_tab">

                                                <div className="form_control">
                                                    <div className="fieldName">Okres</div>
                                                    <InputComboRokMiesiac  userData={props.userData} mainView={props.mainView}   value={filterParam.okres} err={null}  valChange={valChangeListener} goNext={null} name="okres" placeholder={""} className=' ' req='0' firstUp="0" />
                                                </div>
        
                                                <div className="form_control">
                                                    <div className="fieldName">Grupa</div>
                                                    <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                                </div>     
                                                
                                        
                                </div>

                                
                                <div className="form_split"></div>

                                <div className="form_btn">
                                        {
                                            showPDF &&
                                            <Fragment>
                                                <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }

                                        {
                                            showXLS &&
                                            <Fragment>
                                                <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }
                                    
                                </div>
            </form>

        }        
                   
    if(uqSelected == "00000000018")
            {
        
                return  <form className="eForm bg_center">
    
                                    <br/>
                                    <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                    <h3>{xTitle}</h3>    
    
                                    <div className="form_tab">
    
                                                    <div className="form_control">
                                                        <div className="fieldName">Okres</div>
                                                        <InputComboRokMiesiac  userData={props.userData} mainView={props.mainView}   value={filterParam.okres} err={null}  valChange={valChangeListener} goNext={null} name="okres" placeholder={""} className=' ' req='0' firstUp="0" />
                                                    </div>
            
                                                    <div className="form_control">
                                                        <div className="fieldName">Grupa</div>
                                                        <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                                    </div>     
                                                    
                                            
                                    </div>
    
                                    
                                    <div className="form_split"></div>
    
                                    <div className="form_btn">
                                            {
                                                showPDF &&
                                                <Fragment>
                                                    <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                    &nbsp;&nbsp;
                                                </Fragment>    
                                            }
    
                                            {
                                                showXLS &&
                                                <Fragment>
                                                    <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                    &nbsp;&nbsp;
                                                </Fragment>    
                                            }
                                        
                                    </div>
                </form>
    
            }        
                    




    if(uqSelected == "00000000019")
        {
    
            return  <form className="eForm bg_center">

                                <br/>
                                <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                <h3>{xTitle}</h3>    

                                <div className="form_tab">

                                                <div className="form_control">
                                                    <div className="fieldName">Od dnia</div>
                                                    <InputDate  userData={props.userData} mainView={props.mainView}   value={filterParam.okres_od} err={null}  valChange={valChangeListener} goNext={null} name="okres_od" placeholder={""} className=' ' req='0' firstUp="0" />
                                                </div>

                                                <div className="form_control">
                                                    <div className="fieldName">Do dnia</div>
                                                    <InputDate  userData={props.userData} mainView={props.mainView}   value={filterParam.okres_do} err={null}  valChange={valChangeListener} goNext={null} name="okres_do" placeholder={""} className=' ' req='0' firstUp="0" />
                                                </div>
        
                                                <div className="form_control">
                                                    <div className="fieldName">Grupa</div>
                                                    <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                                </div>     
                                                
                                        
                                </div>

                                
                                <div className="form_split"></div>

                                <div className="form_btn">
                                        {
                                            showPDF &&
                                            <Fragment>
                                                <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }

                                        {
                                            showXLS &&
                                            <Fragment>
                                                <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }
                                    
                                </div>
            </form>

        }        
      


        

    if(uqSelected == "00000000020")
            {
    
            return  <form className="eForm bg_center">

                                <br/>
                                <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                <h3>{xTitle}</h3>    

                                <div className="form_tab">

                                                <div className="form_control">
                                                    <div className="fieldName">Okres</div>
                                                    <InputComboRokMiesiac  userData={props.userData} mainView={props.mainView}   value={filterParam.okres} err={null}  valChange={valChangeListener} goNext={null} name="okres" placeholder={""} className=' ' req='0' firstUp="0" />
                                                </div>

                                             
        
                                                <div className="form_control">
                                                    <div className="fieldName">Grupa</div>
                                                    <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                                </div>    

                                                 <div className="form_control">
                                                    <div className="fieldName">Przelewy</div>
                                                    <InputCombo  items={   [  {v:'_x_', title: ' - - -'},   {v:'1', title: 'Pokaż przelewy tylko z tego miesiąca'}, ] }  value={filterParam.extra_combo} err={null}  valChange={valChangeListener} goNext={null} name="extra_combo" placeholder={""} className=' ' req='0' firstUp="0" />
                                                </div>    
                                                
                                        
                                </div>

                                
                                <div className="form_split"></div>

                                <div className="form_btn">
                                        {
                                            showPDF &&
                                            <Fragment>
                                                <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }

                                        {
                                            showXLS &&
                                            <Fragment>
                                                <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }
                                    
                                </div>
            </form>

        }        
                  


    if(uqSelected == "00000000021")
        {

        return  <form className="eForm bg_center">

                            <br/>
                            <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                            <h3>{xTitle}</h3>    

                            <div className="form_tab">

                                            <div className="form_control">
                                                <div className="fieldName">Okres</div>
                                                <InputComboRokMiesiac  userData={props.userData} mainView={props.mainView}   value={filterParam.okres} err={null}  valChange={valChangeListener} goNext={null} name="okres" placeholder={""} className=' ' req='0' firstUp="0" />
                                            </div>

                                            
    
                                            <div className="form_control">
                                                <div className="fieldName">Grupa</div>
                                                <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                            </div>     
                                            
                                    
                            </div>

                            
                            <div className="form_split"></div>

                            <div className="form_btn">
                                    {
                                        showPDF &&
                                        <Fragment>
                                            <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                            &nbsp;&nbsp;
                                        </Fragment>    
                                    }

                                    {
                                        showXLS &&
                                        <Fragment>
                                            <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                            &nbsp;&nbsp;
                                        </Fragment>    
                                    }
                                
                            </div>
        </form>

    }        
                  


    if(uqSelected == "00000000022")
        {

        return  <form className="eForm bg_center">

                            <br/>
                            <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                            <h3>{xTitle}</h3>    

                            <div className="form_tab">

                                            <div className="form_control">
                                                <div className="fieldName">Okres</div>
                                                <InputComboRokMiesiac  userData={props.userData} mainView={props.mainView}   value={filterParam.okres} err={null}  valChange={valChangeListener} goNext={null} name="okres" placeholder={""} className=' ' req='0' firstUp="0" />
                                            </div>

                                            
    
                                            <div className="form_control">
                                                <div className="fieldName">Grupa</div>
                                                <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                            </div>     
                                            
                                    
                            </div>

                            
                            <div className="form_split"></div>

                            <div className="form_btn">
                                    {
                                        showPDF &&
                                        <Fragment>
                                            <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                            &nbsp;&nbsp;
                                        </Fragment>    
                                    }

                                    {
                                        showXLS &&
                                        <Fragment>
                                            <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                            &nbsp;&nbsp;
                                        </Fragment>    
                                    }
                                
                            </div>
        </form>

    }   
    
    

    if(uqSelected == "00000000023")
        {

        return  <form className="eForm bg_center">

                            <br/>
                            <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                            <h3>{xTitle}</h3>    

                            <div className="form_tab">

                                            <div className="form_control">
                                                <div className="fieldName">Okres</div>
                                                <InputComboRok userData={props.userData} mainView={props.mainView}   value={filterParam.okres} err={null}  valChange={valChangeListener} goNext={null} name="okres" placeholder={""} className=' ' req='0' firstUp="0" />
                                            </div>

                                       
                            </div>

                            
                            <div className="form_split"></div>

                            <div className="form_btn">
                                    {
                                        showPDF &&
                                        <Fragment>
                                            <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                            &nbsp;&nbsp;
                                        </Fragment>    
                                    }

                                    {
                                        showXLS &&
                                        <Fragment>
                                            <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                            &nbsp;&nbsp;
                                        </Fragment>    
                                    }
                                
                            </div>
        </form>

    }        
        
          

    if(uqSelected == "00000000024")
        {

        return  <form className="eForm bg_center">

                            <br/>
                            <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                            <h3>{xTitle}</h3>    

                            <div className="form_tab">

                                            
    
                                            <div className="form_control">
                                                <div className="fieldName">Grupa</div>
                                                <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                            </div>     
                                            
                                    
                            </div>

                            
                            <div className="form_split"></div>

                            <div className="form_btn">
                                    {
                                        showPDF &&
                                        <Fragment>
                                            <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                            &nbsp;&nbsp;
                                        </Fragment>    
                                    }

                                    {
                                        showXLS &&
                                        <Fragment>
                                            <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                            &nbsp;&nbsp;
                                        </Fragment>    
                                    }
                                
                            </div>
        </form>

    }   
    



    if(uqSelected == "00000000025")
        {

        return  <form className="eForm bg_center">

                            <br/>
                            <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                            <h3>{xTitle}</h3>    

                            <div className="form_tab">

                                            <div className="form_control">
                                                <div className="fieldName">Okres</div>
                                                <InputComboRok userData={props.userData} mainView={props.mainView}   value={filterParam.rok} err={null}  valChange={valChangeListener} goNext={null} name="rok" placeholder={""} className=' ' req='0' firstUp="0" />
                                            </div>

                                       
                            </div>

                            
                            <div className="form_split"></div>

                            <div className="form_btn">
                                    {
                                        showPDF &&
                                        <Fragment>
                                            <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                            &nbsp;&nbsp;
                                        </Fragment>    
                                    }

                                    {
                                        showXLS &&
                                        <Fragment>
                                            <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                            &nbsp;&nbsp;
                                        </Fragment>    
                                    }
                                
                            </div>
        </form>

    }   







    if(uqSelected == "00000000026")
        {

             return  <form className="eForm bg_center">

                        <br/>
                        <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                        <h3>{xTitle}</h3>    

                        <div className="form_tab">

                                        

                                        <div className="form_control">
                                            <div className="fieldName">Grupa</div>
                                            <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                        </div>     
                                        
                                
                        </div>

                        
                        <div className="form_split"></div>

                        <div className="form_btn">
                                {
                                    showPDF &&
                                    <Fragment>
                                        <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                        &nbsp;&nbsp;
                                    </Fragment>    
                                }

                                {
                                    showXLS &&
                                    <Fragment>
                                        <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                        &nbsp;&nbsp;
                                    </Fragment>    
                                }
                            
                        </div>
    </form>

}   



if(uqSelected == "00000000027")
    {

            return  <form className="eForm bg_center">

                        <br/>
                        <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                        <h3>{xTitle}</h3>    

                        <div className="form_tab">

                                        

                                        <div className="form_control">
                                            <div className="fieldName">Grupa</div>
                                            <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                        </div>    

                                         <div className="form_control">
                                            <div className="fieldName">Okres</div>
                                            <InputComboRokMiesiac  userData={props.userData} mainView={props.mainView}   value={filterParam.miesiac} err={null}  valChange={valChangeListener} goNext={null} name="miesiac" placeholder={""} className=' ' req='0' firstUp="0" />
                                        </div>  
                                        
                                
                        </div>

                        
                        <div className="form_split"></div>

                        <div className="form_btn">
                                {
                                    showPDF &&
                                    <Fragment>
                                        <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                        &nbsp;&nbsp;
                                    </Fragment>    
                                }

                                {
                                    showXLS &&
                                    <Fragment>
                                        <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                        &nbsp;&nbsp;
                                    </Fragment>    
                                }
                            
                        </div>
    </form>

    }   





    if(uqSelected == "00000000028")
        {
    
                return  <form className="eForm bg_center">
    
                            <br/>
                            <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                            <h3>{xTitle}</h3>    
    
                            <div className="form_tab">
    
                                            
    
                                            <div className="form_control">
                                                <div className="fieldName">Grupa</div>
                                                <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                            </div>    
    
                                             <div className="form_control">
                                                <div className="fieldName">Okres</div>
                                                <InputComboRokMiesiac  userData={props.userData} mainView={props.mainView}   value={filterParam.miesiac} err={null}  valChange={valChangeListener} goNext={null} name="miesiac" placeholder={""} className=' ' req='0' firstUp="0" />
                                            </div>  
                                            
                                    
                            </div>
    
                            
                            <div className="form_split"></div>
    
                            <div className="form_btn">
                                    {
                                        showPDF &&
                                        <Fragment>
                                            <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                            &nbsp;&nbsp;
                                        </Fragment>    
                                    }
    
                                    {
                                        showXLS &&
                                        <Fragment>
                                            <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                            &nbsp;&nbsp;
                                        </Fragment>    
                                    }
                                
                            </div>
        </form>
    
        }   



        if(uqSelected == "00000000029")
            {
        
                    return  <form className="eForm bg_center">
        
                                <br/>
                                <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                <h3>{xTitle}</h3>    
        
                                <div className="form_tab">
        
                                                
        
                                                <div className="form_control">
                                                    <div className="fieldName">Od dnia</div>
                                                    <InputDate  userData={props.userData} mainView={props.mainView}   value={filterParam.data_od} err={null}  valChange={valChangeListener} goNext={null} name="data_od" placeholder={""} className=' ' req='0' firstUp="0" />
                                                </div>    
        
                                                 <div className="form_control">
                                                    <div className="fieldName">Do dnia</div>
                                                    <InputDate  userData={props.userData} mainView={props.mainView}   value={filterParam.data_do} err={null}  valChange={valChangeListener} goNext={null} name="data_do" placeholder={""} className=' ' req='0' firstUp="0" />
                                                </div>  
                                                
                                        
                                </div>
        
                                
                                <div className="form_split"></div>
        
                                <div className="form_btn">
                                        {
                                            showPDF &&
                                            <Fragment>
                                                <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }
        
                                        {
                                            showXLS &&
                                            <Fragment>
                                                <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }
                                    
                                </div>
            </form>
        
            }    
            
            

            if(uqSelected == "00000000030")
                {
            
                        return  <form className="eForm bg_center">
            
                                    <br/>
                                    <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                    <h3>{xTitle}</h3>    
            
                                    <div className="form_tab">
            
                                                    
            
                                                    <div className="form_control">
                                                        <div className="fieldName">Grupa</div>
                                                        <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                                    </div>    
             
                                                    
                                            
                                    </div>
            
                                    
                                    <div className="form_split"></div>
            
                                    <div className="form_btn">
                                            {
                                                showPDF &&
                                                <Fragment>
                                                    <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                    &nbsp;&nbsp;
                                                </Fragment>    
                                            }
            
                                            {
                                                showXLS &&
                                                <Fragment>
                                                    <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                    &nbsp;&nbsp;
                                                </Fragment>    
                                            }
                                        
                                    </div>
                </form>
            
                }  



        if(uqSelected == "00000000031")
            {

                 var lata = [
                    { v:12, title: 'kończące 1 (lat)' },
                    { v:18, title: 'kończące 1,5 (lat)' },
                    { v:24, title: 'kończące 2 (lat)' },
                    { v:30, title: 'kończące 2,5 (lat)' },
                    { v:36, title: 'kończące 3 (lat)' },
                 ];
        
                    return  <form className="eForm bg_center">
        
                                <br/>
                                <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                <h3>{xTitle}</h3>    
        
                                <div className="form_tab">
        
                                                
                                                <div className="form_control">
                                                        <div className="fieldName">Grupa</div>
                                                        <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                                    </div> 
                                              
                                                 <div className="form_control">
                                                    <div className="fieldName">Od dnia</div>
                                                    <InputDate  userData={props.userData} mainView={props.mainView}   value={filterParam.data_od} err={null}  valChange={valChangeListener} goNext={null} name="data_od" placeholder={""} className=' ' req='0' firstUp="0" />
                                                </div>    
        
                                                 <div className="form_control">
                                                    <div className="fieldName">Do dnia</div>
                                                    <InputDate  userData={props.userData} mainView={props.mainView}   value={filterParam.data_do} err={null}  valChange={valChangeListener} goNext={null} name="data_do" placeholder={""} className=' ' req='0' firstUp="0" />
                                                </div>  


                                                 <div className="form_control">
                                                        <div className="fieldName">Wiek</div>
                                                        <InputCombo items={lata}  userData={props.userData} mainView={props.mainView}   value={filterParam.wiek} err={null}  valChange={valChangeListener} goNext={null} name="wiek" placeholder={""} className=' ' req='0' firstUp="0" />
                                                    </div>   
            
                                                
                                        
                                </div>
        
                                
                                <div className="form_split"></div>
        
                                <div className="form_btn">
                                        {
                                            showPDF &&
                                            <Fragment>
                                                <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }
        
                                        {
                                            showXLS &&
                                            <Fragment>
                                                <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                &nbsp;&nbsp;
                                            </Fragment>    
                                        }
                                    
                                </div>
            </form>
        
            }     
            
            
            

            if(uqSelected == "00000000032_1")
                {
            
                        return  <form className="eForm bg_center">
            
                                    <br/>
                                    <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                    <h3>{xTitle}</h3>    
            
                                    <div className="form_tab">
            
            
                                                    <div className="form_control">
                                                        <div className="fieldName">Grupa</div>
                                                        <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                                    </div>   
                                                    
            
                                                    <div className="form_control">
                                                        <div className="fieldName">Okres</div>
                                                        <InputComboRokMiesiac  userData={props.userData} mainView={props.mainView}   value={filterParam.miesiac} err={null}  valChange={valChangeListener} goNext={null} name="miesiac" placeholder={""} className=' ' req='0' firstUp="0" />
                                                    </div>    

                                                    <div className="form_control">
                                                        <div className="fieldName">Subkonto</div>
                                                        <InputComboSubkonto userData={props.userData} mainView={props.mainView}   value={filterParam.p_subkonta_id} err={null}  valChange={valChangeListener} goNext={null} name="p_subkonta_id" placeholder={""} className=' ' req='0' firstUp="0" />
                                                    </div>    
             
                                                    
                                            
                                    </div>
            
                                    
                                    <div className="form_split"></div>
            
                                    <div className="form_btn">
                                    {
                                                showPDF &&
                                                <Fragment>
                                                    <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                    &nbsp;&nbsp;
                                                </Fragment>    
                                            }
            
                                            {
                                                showXLS &&
                                                <Fragment>
                                                    <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                    &nbsp;&nbsp;
                                                </Fragment>    
                                            }
            
                                           
                                        
                                    </div>
                </form>
            
                }  






            if(uqSelected == "00000000032")
                {
            
                        return  <form className="eForm bg_center">
            
                                    <br/>
                                    <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                    <h3>{xTitle}</h3>    
            
                                    <div className="form_tab">
            
            
                                                    <div className="form_control">
                                                        <div className="fieldName">Grupa</div>
                                                        <InputComboGrupa all="1"  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                                    </div>   
                                                    
            
                                                    <div className="form_control">
                                                        <div className="fieldName">Okres</div>
                                                        <InputComboRokMiesiac  userData={props.userData} mainView={props.mainView}   value={filterParam.miesiac} err={null}  valChange={valChangeListener} goNext={null} name="miesiac" placeholder={""} className=' ' req='0' firstUp="0" />
                                                    </div>    

                                                    <div className="form_control">
                                                        <div className="fieldName">Subkonto</div>
                                                        <InputComboSubkonto userData={props.userData} mainView={props.mainView}   value={filterParam.p_subkonta_id} err={null}  valChange={valChangeListener} goNext={null} name="p_subkonta_id" placeholder={""} className=' ' req='0' firstUp="0" />
                                                    </div>    
             
                                                    
                                            
                                    </div>
            
                                    
                                    <div className="form_split"></div>
            
                                    <div className="form_btn">
                                            {
                                                showPDF &&
                                                <Fragment>
                                                    <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                    &nbsp;&nbsp;
                                                </Fragment>    
                                            }
            
                                           
                                        
                                    </div>
                </form>
            
                }  






                
            if(uqSelected == "00000000033")
                {
            
                        return  <form className="eForm bg_center">
            
                                    <br/>
                                    <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                    <h3>{xTitle}</h3>    
            
                                    <div className="form_tab">
            
             
            
                                                    <div className="form_control">
                                                        <div className="fieldName">Okres</div>
                                                        <InputComboRokMiesiac  userData={props.userData} mainView={props.mainView}   value={filterParam.miesiac} err={null}  valChange={valChangeListener} goNext={null} name="miesiac" placeholder={""} className=' ' req='0' firstUp="0" />
                                                    </div>    

                                                    <div className="form_control">
                                                        <div className="fieldName">Subkonto</div>
                                                        <InputComboSubkonto userData={props.userData} mainView={props.mainView}   value={filterParam.p_subkonta_id} err={null}  valChange={valChangeListener} goNext={null} name="p_subkonta_id" placeholder={""} className=' ' req='0' firstUp="0" />
                                                    </div>    
             
                                                    
                                            
                                    </div>
            
                                    
                                    <div className="form_split"></div>
            
                                    <div className="form_btn">
                                            {
                                                showPDF &&
                                                <Fragment>
                                                    <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                    &nbsp;&nbsp;
                                                </Fragment>    
                                            }
            
                                            {
                                                showXLS &&
                                                <Fragment>
                                                    <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                    &nbsp;&nbsp;
                                                </Fragment>    
                                            }
                                        
                                    </div>
                </form>
            
                }  



                if(uqSelected == "00000000034")
                    {
                
                            return  <form className="eForm bg_center">
                
                                        <br/>
                                        <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                        <h3>{xTitle}</h3>    
                
                                        <div className="form_tab">
                                                       
                                                        <div className="form_control">
                                                            <div className="fieldName">Subkonto</div>
                                                            <InputComboSubkonto userData={props.userData} mainView={props.mainView}   value={filterParam.p_subkonta_id} err={null}  valChange={valChangeListener} goNext={null} name="p_subkonta_id" placeholder={""} className=' ' req='0' firstUp="0" />
                                                        </div>                                                                                                                             
                                        </div>
                
                                        
                                        <div className="form_split"></div>
                
                                        <div className="form_btn">
                                                {
                                                    showPDF &&
                                                    <Fragment>
                                                        <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                        &nbsp;&nbsp;
                                                    </Fragment>    
                                                }
                
                                                {
                                                    showXLS &&
                                                    <Fragment>
                                                        <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                        &nbsp;&nbsp;
                                                    </Fragment>    
                                                }
                                            
                                        </div>
                    </form>
                
                    }  

                    


            if(uqSelected == "00000000035")
               {
                    
                                return  <form className="eForm bg_center">
                    
                                            <br/>
                                            <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                            <h3>{xTitle}</h3>    
                    
                                            <div className="form_tab">
                    
                    
                                                            <div className="form_control">
                                                                <div className="fieldName">Grupa</div>
                                                                <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                                            </div>   
                                                            
                    
                                                            <div className="form_control">
                                                                <div className="fieldName">Okres</div>
                                                                <InputComboRokMiesiac  userData={props.userData} mainView={props.mainView}   value={filterParam.miesiac} err={null}  valChange={valChangeListener} goNext={null} name="miesiac" placeholder={""} className=' ' req='0' firstUp="0" />
                                                            </div>    
        
                                                            <div className="form_control">
                                                                <div className="fieldName">Subkonto</div>
                                                                <InputComboSubkonto userData={props.userData} mainView={props.mainView}   value={filterParam.p_subkonta_id} err={null}  valChange={valChangeListener} goNext={null} name="p_subkonta_id" placeholder={""} className=' ' req='0' firstUp="0" />
                                                            </div>    
                     
                                                            
                                                    
                                            </div>
                    
                                            
                                            <div className="form_split"></div>
                    
                                            <div className="form_btn">
                                            {
                                                        showPDF &&
                                                        <Fragment>
                                                            <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                            &nbsp;&nbsp;
                                                        </Fragment>    
                                                    }
                    
                                                    {
                                                        showXLS &&
                                                        <Fragment>
                                                            <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz .XLS</div>
                                                            &nbsp;&nbsp;
                                                        </Fragment>    
                                                    }
                    
                                                   
                                                
                                            </div>
                        </form>
                    
                        }  
        
        


            if(uqSelected == "00000000036")
            {

                var tygodnie = [
                    {v: "t1", title: "Tydzień I" },
                    {v: "t2", title: "Tydzień II" },
                    {v: "t3", title: "Tydzień III" },
                    {v: "t4", title: "Tydzień IV" },
                    {v: "t5", title: "Tydzień V" },
                ];
                                 
                                             return  <form className="eForm bg_center">
                                 
                                                         <br/>
                                                         <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                                         <h3>{xTitle}</h3>    
                                 
                                                         <div className="form_tab">
                                 
                                 
                                                                         <div className="form_control">
                                                                             <div className="fieldName">Grupa</div>
                                                                             <InputComboGrupa  userData={props.userData} mainView={props.mainView}   value={filterParam.grupa} err={null}  valChange={valChangeListener} goNext={null} name="grupa" placeholder={""} className=' ' req='0' firstUp="0" />
                                                                         </div>   
                                                                         
                                 
                                                                         <div className="form_control">
                                                                             <div className="fieldName">Okres</div>
                                                                             <InputComboRokMiesiac  userData={props.userData} mainView={props.mainView}   value={filterParam.miesiac} err={null}  valChange={valChangeListener} goNext={null} name="miesiac" placeholder={""} className=' ' req='0' firstUp="0" />
                                                                         </div>    

                                                                         <div className="form_control">
                                                                             <div className="fieldName">Tydzień</div>
                                                                             <InputCombo items={tygodnie}  userData={props.userData} mainView={props.mainView}   value={filterParam.tydzien} err={null}  valChange={valChangeListener} goNext={null} name="tydzien" placeholder={""} className=' ' req='0' firstUp="0" />
                                                                         </div>    
                        
                                                         </div>
                                 
                                                         
                                                         <div className="form_split"></div>
                                 
                                                         <div className="form_btn">
                                                         {
                                                                     showPDF &&
                                                                     <Fragment>
                                                                         <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz .PDF</div>
                                                                         &nbsp;&nbsp;
                                                                     </Fragment>    
                                                                 }
                                  
                                 
                                                                
                                                             
                                                         </div>
                                     </form>
                                 
            }  


            if(uqSelected == "00000000037")
            {
                //ogolny
                return <GmRaportGeneral userData={props.userData} mainView={props.mainView} onBack={onBack} />
            }


            if(uqSelected == "00000000038")
            {
                //bilans kont
                 return <GmAccounts userData={props.userData} mainView={props.mainView} onBack={onBack} />
            }


            
            if(uqSelected == "00000000039")
                    {
                
                            return  <form className="eForm bg_center">
                
                                        <br/>
                                        <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                        <h3>{xTitle}</h3>    

                                        <p>
                                            Systeme eLizak umożliwia export wystawionych faktur VAT do programu Rewizor Nexo. Wybierz okres i pobierz plik EDI++ . Zwróc również uwagę, że tylko wystawione faktury VAT znajdą się w raporcie. System nie umieści tutaj dokumentów typu "zwykłe rozliczenie". 
                                        </p>
                
                                        <div className="form_tab">
                                                       
                                                        <div className="form_control">
                                                            <div className="fieldName">Subkonto</div>
                                                            <InputComboSubkonto userData={props.userData} mainView={props.mainView}   value={filterParam.p_subkonta_id} err={null}  valChange={valChangeListener} goNext={null} name="p_subkonta_id" placeholder={""} className=' ' req='0' firstUp="0" />
                                                        </div>    

                                                          <div className="form_control">
                                                                             <div className="fieldName">Okres</div>
                                                                             <InputComboRokMiesiac  userData={props.userData} mainView={props.mainView}   value={filterParam.miesiac} err={null}  valChange={valChangeListener} goNext={null} name="miesiac" placeholder={""} className=' ' req='0' firstUp="0" />
                                                        </div>                                                                                                                           
                                        </div>
                
                                        
                                        <div className="form_split"></div>
                
                                        <div className="form_btn">                                               
                                                {                                                    
                                                    <Fragment>
                                                        <div className="btn"  atr-format="epp" onClick={goDownload}>Pobierz .epp</div>
                                                        &nbsp;&nbsp;
                                                    </Fragment>    
                                                }
                                            
                                        </div>
                    </form>
                
                    }  
        




            //impreza okolicznosciowa..
                   if(uqSelected == "00000000040") 
                    {
                
                            return  <form className="eForm bg_center">
                
                                        <br/>
                                        <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                        <h3>{xTitle}</h3>    

                                        <p>
                                            Systeme eLizak umożliwia dokonywanie płatności onLine na imprezy okolicznościowe. Więcej informacji na infolinii eLizaka.
                                        </p>
                
                                        <div className="form_tab">
                                                 
                                                 
                                                                         <div className="form_control">
                                                                             <div className="fieldName">Tydzień</div>
                                                                             <InputCombo items={ [ {v:'brak',title:'brak'},  {v:'Rehabilitacja Ruchowa',title:'Rehabilitacja Ruchowa'},    {v:'WF-s.trenerska',title:'WF-s.trenerska'},    {v:'WF-s.nauczycielska',title:'WF-s.nauczycielska'},   {v:'TiR',title:'TiR'},  ] }  userData={props.userData} mainView={props.mainView}   value={filterParam.extra_combo} err={null}  valChange={valChangeListener} goNext={null} name="extra_combo" placeholder={""} className=' ' req='0' firstUp="0" />
                                                                         </div>     
                                                                                                                                                                                
                                        </div>
                
                                        
                                        <div className="form_split"></div>
                
                                        <div className="form_btn">                                               
                                                {                                                    
                                                    <Fragment>
                                                        <div className="btn"  atr-format="pdf" onClick={goDownload}>Pobierz raport płatności .pdf</div>
                                                        &nbsp;&nbsp;
                                                        <div className="btn"  atr-format="xls" onClick={goDownload}>Pobierz raport płatności .xls</div>
                                                    </Fragment>    
                                                }
                                            
                                        </div>
                    </form>
                
                    }                      





            if(uqSelected == "00000000100") //jpk vat
                    {
                
                            return  <form className="eForm bg_center">
                
                                        <br/>
                                        <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                        <h3>{xTitle}</h3>    

                                        <p>
                                            Systeme eLizak umożliwia export wystawionych faktur VAT do programu księgowego. Wybierz okres i pobierz plik JPK VAT. Zwróc również uwagę, że tylko wystawione faktury VAT znajdą się w raporcie. System nie umieści tutaj dokumentów typu "zwykłe rozliczenie". 
                                        </p>
                
                                        <div className="form_tab">
                                                       
                                                        <div className="form_control">
                                                            <div className="fieldName">Subkonto</div>
                                                            <InputComboSubkonto userData={props.userData} mainView={props.mainView}   value={filterParam.p_subkonta_id} err={null}  valChange={valChangeListener} goNext={null} name="p_subkonta_id" placeholder={""} className=' ' req='0' firstUp="0" />
                                                        </div>    

                                                          <div className="form_control">
                                                                             <div className="fieldName">Okres</div>
                                                                             <InputComboRokMiesiac  userData={props.userData} mainView={props.mainView}   value={filterParam.miesiac} err={null}  valChange={valChangeListener} goNext={null} name="miesiac" placeholder={""} className=' ' req='0' firstUp="0" />
                                                        </div>                                                                                                                           
                                        </div>
                
                                        
                                        <div className="form_split"></div>
                
                                        <div className="form_btn">                                               
                                                {                                                    
                                                    <Fragment>
                                                        <div className="btn"  atr-format="epp" onClick={goDownload}>Pobierz .xml</div>
                                                        &nbsp;&nbsp;
                                                    </Fragment>    
                                                }
                                            
                                        </div>
                    </form>
                
                    }  


            if(uqSelected == "00000000100FA") //jpk vat FA
                    {
                
                            return  <form className="eForm bg_center">
                
                                        <br/>
                                        <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                        <h3>{xTitle}</h3>    

                                        <p>
                                            Systeme eLizak umożliwia export wystawionych faktur VAT do programu księgowego. Wybierz okres i pobierz plik JPK VAT. Zwróc również uwagę, że tylko wystawione faktury VAT znajdą się w raporcie. System nie umieści tutaj dokumentów typu "zwykłe rozliczenie". 
                                        </p>
                
                                        <div className="form_tab">
                                                       
                                                        <div className="form_control">
                                                            <div className="fieldName">Subkonto</div>
                                                            <InputComboSubkonto userData={props.userData} mainView={props.mainView}   value={filterParam.p_subkonta_id} err={null}  valChange={valChangeListener} goNext={null} name="p_subkonta_id" placeholder={""} className=' ' req='0' firstUp="0" />
                                                        </div>    

                                                          <div className="form_control">
                                                                             <div className="fieldName">Okres</div>
                                                                             <InputComboRokMiesiac  userData={props.userData} mainView={props.mainView}   value={filterParam.miesiac} err={null}  valChange={valChangeListener} goNext={null} name="miesiac" placeholder={""} className=' ' req='0' firstUp="0" />
                                                        </div>                                                                                                                           
                                        </div>
                
                                        
                                        <div className="form_split"></div>
                
                                        <div className="form_btn">                                               
                                                {                                                    
                                                    <Fragment>
                                                        <div className="btn"  atr-format="epp" onClick={goDownload}>Pobierz .xml</div>
                                                        &nbsp;&nbsp;
                                                    </Fragment>    
                                                }
                                            
                                        </div>
                    </form>
                
                    }

    
            if(uqSelected == "00000000101") //optioma
                    {
                
                            return  <form className="eForm bg_center">
                
                                        <br/>
                                        <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                        <h3>{xTitle}</h3>    

                                        <p>
                                            Systeme eLizak umożliwia export wystawionych faktur VAT do programu Comarch ERP Optima w postaciu katalogu zawierającego pliki XML. Pobierz plik .zip, rozpakuj na swoim komputerze i zaimportuj dokument do programu księgowego. Więcej znajdziesz tutaj: <a href="https://pomoc.comarch.pl/optima/pl/2023_5/index.php/dokumentacja/eksport-i-import-dokumentow-przez-pliki-xml/" target="_blank">https://pomoc.comarch.pl/optima/pl/2023_5/index.php/dokumentacja/eksport-i-import-dokumentow-przez-pliki-xml/</a>. 
                                        </p>
                
                                        <div className="form_tab">
                                                       
                                                        <div className="form_control">
                                                            <div className="fieldName">Subkonto</div>
                                                            <InputComboSubkonto userData={props.userData} mainView={props.mainView}   value={filterParam.p_subkonta_id} err={null}  valChange={valChangeListener} goNext={null} name="p_subkonta_id" placeholder={""} className=' ' req='0' firstUp="0" />
                                                        </div>    

                                                          <div className="form_control">
                                                                             <div className="fieldName">Okres</div>
                                                                             <InputComboRokMiesiac  userData={props.userData} mainView={props.mainView}   value={filterParam.miesiac} err={null}  valChange={valChangeListener} goNext={null} name="miesiac" placeholder={""} className=' ' req='0' firstUp="0" />
                                                        </div>                                                                                                                           
                                        </div>
                
                                        
                                        <div className="form_split"></div>
                
                                        <div className="form_btn">                                               
                                                {                                                    
                                                    <Fragment>
                                                        <div className="btn"  atr-format="epp" onClick={goDownload}>Pobierz katalog .zip</div>
                                                        &nbsp;&nbsp;
                                                    </Fragment>    
                                                }
                                            
                                        </div>
                    </form>
                
                    }  



   var isSomeFav = false;
   
   for(var w=0; w < list.length; w++)
   { 
            for(var k=0; k<fav.length; k++)
            {
                    if(fav[k].uq == list[w].uq) isSomeFav = true;
            }    
   }


    return <div>
           

            {
                isSomeFav &&
                <div>

                    <br/>

                    <div className="calColor">Ulubione: </div>


                    <ul className="rap_list">
                    
                                        {
                                                list.map( (row, ix) => { 

                                                    var isFav = false;
                                                    for(var k=0; k<fav.length; k++)
                                                        {
                                                            if(fav[k].uq == row.uq) isFav = true;
                                                        }

                                                        if(isFav == false) return null;

                                                        return <li atr-type={row.uq}  onClick={goRaport}>
                                                    
                                                        {
                                                            isFav == true  &&
                                                            <img src={fav_y} className="fav_ico" alt="Usuń z ulubionych" title="Usuń z ulubionych"  uq={row.uq} nazwa={row.name} onClick={removeFav} />
                                                        }
                                                        &nbsp;
                                                        {
                                                            row.review != null &&
                                                            <Fragment>
                                                                &nbsp;    
                                                                <span className="fav_review_screen" atr-type={row.uq}  onClick={goRaport}>
                                                                     <img src={row.review} />
                                                                </span>
                                                                &nbsp;    
                                                            </Fragment>                                                            
                                                        }
                                                    
                                                    &nbsp; {row.name}
                                                    &nbsp;
                                                    (     
                                                        {
                                                            row.pdf == true &&
                                                            <span>&nbsp;.pdf&nbsp; </span>
                                                        }
                                                        {
                                                            row.xls == true &&
                                                            <span>&nbsp;.xls&nbsp; </span>
                                                        }
                                                        {
                                                             row.epp != undefined && row.epp == true &&
                                                            <span>&nbsp;.xls&nbsp; </span>
                                                        }
                                                        {
                                                             row.xml != undefined && row.xml == true &&
                                                            <span>&nbsp;.xml&nbsp; </span>
                                                        }
                                                        {
                                                             row.zip != undefined && row.zip == true &&
                                                            <span>&nbsp;.zip&nbsp; </span>
                                                        }
                                                    )

                                                    </li>


                                                })

                                        }

                                </ul>


                </div>
            }

           


             <br/>          

             {
                isSomeFav == true &&
                <div>

                    <div className="calColor">Pozostałe: </div>

                </div>
             }

             <ul className="rap_list">



                    {
                        list.map( (row, ix) => {


                            var tN = row.name.toLowerCase();
                            var tS = search.toLowerCase();
                            var show = true;
                            var isFav = false;

                            if(tS.length > 1)
                            {
                                show = false;
                                if(tN.includes(tS)) show = true;
                            }

                            if(!show) return null;


                            for(var k=0; k<fav.length; k++)
                            {
                                if(fav[k].uq == row.uq) isFav = true;
                            }


                            return <li atr-type={row.uq}  onClick={goRaport}>
                                   {
                                     isFav == false  &&
                                     <img src={fav_n} className="fav_ico" alt="Dodaj do ulubionych" title="Dodaj do ulubionych"  uq={row.uq} nazwa={row.name} onClick={addFav} />
                                   }

                                   {
                                     isFav == true  &&
                                     <img src={fav_y} className="fav_ico" alt="Usuń z ulubionych" title="Usuń z ulubionych"  uq={row.uq} nazwa={row.name} onClick={removeFav} />
                                   }

                                    &nbsp;
                                   {
                                                            row.review != null &&
                                                            <Fragment>
                                                                &nbsp;    
                                                                <span className="fav_review_screen" atr-type={row.uq}  onClick={goRaport}>
                                                                     <img src={row.review} />
                                                                </span>
                                                                &nbsp;    
                                                            </Fragment>                                                            
                                    }
                                   
                                   &nbsp; {row.name}
                                   &nbsp;
                                   (     
                                    {
                                        row.pdf == true &&
                                        <span>&nbsp;.pdf&nbsp; </span>
                                    }
                                    {
                                        row.xls == true &&
                                        <span>&nbsp;.xls&nbsp; </span>
                                    }
                                    {
                                        row.epp != undefined && row.epp == true &&
                                        <span>&nbsp;.epp&nbsp; </span>
                                    }
                                    {
                                        row.xml != undefined && row.xml == true &&
                                        <span>&nbsp;.xml&nbsp; </span>
                                    }
                                    {
                                        row.zip != undefined && row.zip == true &&
                                        <span>&nbsp;.zip&nbsp; </span>
                                    }
                                   )
                            </li>
                        } )
                    }

             </ul>






    </div>
}



export default ToExport;